var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "h-14 px-6 sticky z-40 left-0 top-24 flex items-center justify-between bg-slate-300",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _vm.enableBranch
                  ? _c("BlSelectBox", {
                      staticClass: "max-w-48",
                      attrs: {
                        type: "branch",
                        options: _vm.branchOptions,
                        search: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.selectedBranchId = $event
                        }
                      },
                      model: {
                        value: _vm.selectedBranchId,
                        callback: function($$v) {
                          _vm.selectedBranchId = $$v
                        },
                        expression: "selectedBranchId"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-shrink-0" },
                  [_c("BlTextBody2", { attrs: { text: _vm.masterDate } })],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c(
                  "div",
                  [
                    _c("BlSelectBox", {
                      attrs: { options: _vm.timeslotViewOptions, dense: "" },
                      on: {
                        change: function($event) {
                          return _vm.$emit("set-timeslot-view", $event)
                        }
                      },
                      model: {
                        value: _vm.timeslotView,
                        callback: function($$v) {
                          _vm.timeslotView = $$v
                        },
                        expression: "timeslotView"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "Jump to" },
                  on: {
                    clicked: function($event) {
                      _vm.jumpToOpened = true
                    }
                  }
                }),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "Today" },
                  on: {
                    clicked: function($event) {
                      return _vm.onDayClick({ date: null })
                    }
                  }
                }),
                _vm._v(" "),
                _c("BlInputButton", {
                  staticClass: "rounded-full",
                  attrs: { type: "outlined", dense: "", icon: "chevron-left" },
                  on: {
                    clicked: function($event) {
                      return _vm.onNextClick(-1)
                    }
                  }
                }),
                _vm._v(" "),
                _c("BlInputButton", {
                  staticClass: "rounded-full",
                  attrs: { type: "outlined", dense: "", icon: "chevron-right" },
                  on: {
                    clicked: function($event) {
                      return _vm.onNextClick(1)
                    }
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "h-12 flex sticky z-20 top-38 bg-slate-200" },
            [
              _c("div", {
                staticClass:
                  "h-12 w-20 sticky z-10 left-0 flex-shrink-0 bg-slate-200 border-b border-slate-400"
              }),
              _vm._v(" "),
              _vm._l(_vm.headers, function(n, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass:
                      "h-12 py-1 px-2 flex-shrink-0 flex items-center justify-center border-b border-slate-400",
                    style: { width: "calc(" + _vm.slotWidth + ")" }
                  },
                  [
                    _vm.enableBranch && n.branch
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "h-7 px-2 flex items-center justify-center rounded truncate",
                            style: {
                              backgroundColor:
                                n.branch.background_color || "unset"
                            },
                            attrs: { title: n.label + " - " + n.branch.name }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "whitespace-no-wrap truncate",
                              style: { color: n.branch.color || "unset" },
                              attrs: { text: n.label }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "h-7 truncate px-4",
                            attrs: { title: n.label }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: n.label }
                            })
                          ],
                          1
                        )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-col relative bg-slate-200" },
            [
              _vm._l(_vm.clockRound, function(time) {
                return _c(
                  "div",
                  {
                    key: time,
                    staticClass: "flex",
                    attrs: { id: "recurring_time_view_" + time }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-20 py-2 px-3 flex-shrink-0 sticky z-10 left-0 bg-slate-200 flex justify-end border-b border-r border-slate-400 transition-all duration-300",
                        style: { height: _vm.slotHeight * 2 + "rem" }
                      },
                      [_c("BlTextBody2", { attrs: { text: time } })],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.headers, function(n, idx) {
                      return _c("div", {
                        key: idx,
                        staticClass:
                          "flex-shrink-0 flex flex-col gap-2 items-center justify-center border-b border-r border-slate-400 bg-slate-200 transition-all duration-300",
                        style: {
                          height: _vm.slotHeight * 2 + "rem",
                          width: "calc(" + _vm.slotWidth + ")"
                        }
                      })
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              !_vm.timeslotLoading
                ? _c(
                    "div",
                    _vm._l(_vm.filteredTimeslots, function(item, idx) {
                      return _c("AvailableTimeslot", {
                        key: idx,
                        attrs: {
                          isCompact: _vm.timeslotView === "compact",
                          item: item,
                          headers: _vm.headers,
                          slotHeight: _vm.slotHeight,
                          slotWidth: _vm.slotWidth,
                          selectedSlots: _vm.selectedSlots
                        },
                        on: { "add-slot": _vm.onAddSlot }
                      })
                    }),
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fixed z-50 right-6 bottom-6",
          style: { width: "31.25rem" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "h-14 px-6 flex items-center gap-4 rounded-t-3xl bg-light-purple-300 cursor-pointer",
              on: {
                click: function($event) {
                  _vm.chevronOpened = !_vm.chevronOpened
                }
              }
            },
            [
              _c("BlIcon", {
                staticClass: "w-5 h-5 transition-all duration-300",
                style: { rotate: !_vm.chevronOpened ? "180deg" : "" },
                attrs: { icon: "chevron-down", color: "secondary" }
              }),
              _vm._v(" "),
              _c("BlTextSubtitle2", {
                staticClass: "text-pure-white",
                attrs: { text: "Reschedule to a new timeslot" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.chevronOpened
            ? _c(
                "div",
                {
                  staticClass: "bg-pure-white overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 16rem)" }
                },
                [
                  _vm.selectedSlots.length !== _vm.currentSlotCount
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-4 px-6 flex flex-col items-center gap-4 text-center bg-pure-white border border-t-0 border-slate-400"
                        },
                        [
                          _vm.packageItemInputData
                            ? _c(
                                "div",
                                [
                                  _c("BlTextBody2", {
                                    attrs: { text: "This client has" }
                                  }),
                                  _vm._v(" "),
                                  _vm.packageItemInputData
                                    .total_remaining_reschedule_credit === null
                                    ? _c("BlTextBody2", {
                                        staticClass: "font-bold",
                                        attrs: {
                                          text: "unlimited reschedule credit(s)"
                                        }
                                      })
                                    : _c("BlTextBody2", {
                                        staticClass: "font-bold",
                                        attrs: {
                                          text:
                                            _vm.packageItemInputData
                                              .total_remaining_reschedule_credit +
                                            " reschedule credit(s)"
                                        }
                                      }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "available. To reschedule, please choose a timeslot with a duration of"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "font-bold",
                                    attrs: {
                                      text:
                                        _vm.currentSlotCount * 30 + " minutes."
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-25 flex-shrink-0 rounded shadow-md"
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "h-7 flex items-center justify-center rounded-t bg-orange-200"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "w-8 h-8",
                                    attrs: { icon: "sad", color: "orange-6" }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedSlots.length === _vm.currentSlotCount
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-3" },
                              [
                                _vm.selectedAvailability
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-25 flex-shrink-0 rounded shadow-md"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "h-7 flex items-center justify-center rounded-t bg-orange-200"
                                          },
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "text-orange-700",
                                              attrs: {
                                                text: _vm.displayDate(
                                                  _vm.selectedAvailability.date,
                                                  "dddd"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                                          },
                                          [
                                            _c("BlTextTitle4", {
                                              staticClass: "text-orange-700",
                                              attrs: {
                                                text: _vm.displayDate(
                                                  _vm.selectedAvailability.date,
                                                  "DD"
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              staticClass: "text-orange-600",
                                              attrs: {
                                                text: _vm.displayDate(
                                                  _vm.selectedAvailability.date,
                                                  "MMMM"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-80 py-3 px-3 flex flex-col gap-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                        attrs: {
                                          title:
                                            _vm.therapistData.name ||
                                            "The therapist is not yet assigned"
                                        }
                                      },
                                      [
                                        _c("BlIcon", {
                                          staticClass: "w-6 h-6",
                                          attrs: {
                                            icon: "user",
                                            color: "slate-6"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          class: {
                                            "italic ": !_vm.therapistData.name
                                          },
                                          attrs: {
                                            text:
                                              _vm.therapistData.name ||
                                              "The therapist is not yet assigned"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2"
                                      },
                                      [
                                        _c("BlIcon", {
                                          staticClass: "w-6 h-6",
                                          attrs: {
                                            icon: "clock-outline",
                                            color: "slate-6"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: {
                                            text:
                                              _vm.selectedTime
                                                .start_time_string +
                                              " - " +
                                              _vm.selectedTime.end_time_string
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2"
                                      },
                                      [
                                        _c("BlIcon", {
                                          staticClass: "w-6 h-6",
                                          attrs: {
                                            icon: "piggy",
                                            color: "slate-6"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: {
                                            text:
                                              _vm.selectedSlots.length +
                                              " credit(s) used for this schedule"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isOpenRoom
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-1" },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: { text: "Select a therapist" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "Select the therapist for this client."
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-2" },
                                  [
                                    _c("BlSelectBox", {
                                      key:
                                        "select-reschedule-therapist-date=" +
                                        _vm.selectedDate +
                                        "&start_time=" +
                                        _vm.selectedTime.start_time_string +
                                        "&end_time=" +
                                        _vm.selectedTime.end_time_string +
                                        "&room_id=" +
                                        _vm.selectedAvailability.room.id,
                                      attrs: {
                                        search: "",
                                        prefixIcon: "user",
                                        placeholder: "Select therapist",
                                        options: _vm.therapistOptions,
                                        searching: _vm.therapistLoading
                                      },
                                      on: {
                                        change: _vm.onChangeTherapist,
                                        search: _vm.fetchTherapists
                                      },
                                      model: {
                                        value: _vm.therapistInput,
                                        callback: function($$v) {
                                          _vm.therapistInput = $$v
                                        },
                                        expression: "therapistInput"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.therapistInput
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-1" },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: {
                                        text:
                                          "Select credits for this appointment"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text:
                                          "Select the source of credits to apply for this appointment."
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-2" },
                                  [
                                    _c("BlSelectBox", {
                                      key:
                                        "select-package-item-" +
                                        _vm.therapistInput,
                                      attrs: {
                                        search: "",
                                        prefixIcon: "piggy",
                                        placeholder: _vm.creditLoading
                                          ? "Loading ..."
                                          : "Select item",
                                        options: _vm.packageItemOptions,
                                        disabled: !_vm.selectedSlots.length,
                                        drop: "up"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.packageItemIdInput = $event
                                        }
                                      },
                                      model: {
                                        value: _vm.packageItemIdInput,
                                        callback: function($$v) {
                                          _vm.packageItemIdInput = $$v
                                        },
                                        expression: "packageItemIdInput"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.packageItemIdInput
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "py-2 px-3 flex items-center justify-between gap-2 bg-cornflower-200 rounded"
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "text-cornflower-800",
                                          attrs: {
                                            text:
                                              "Remaining credits available for this item"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "h-5.5 w-11 flex items-center justify-center bg-cornflower-800 rounded"
                                          },
                                          [
                                            _c("BlTextSubtitle3", {
                                              staticClass:
                                                "text-cornflower-200",
                                              attrs: {
                                                text: _vm.remainingCredits
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-1" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center mb-2 cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "pl-2 pr-4",
                                        style: { transform: "scale(1.375)" }
                                      },
                                      [
                                        _c("BlInputToggle", {
                                          attrs: {
                                            checked:
                                              _vm.setAssignSupervisorsInput
                                          },
                                          on: {
                                            changed: function($event) {
                                              _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle1", {
                                      attrs: { text: "Assign supervisor" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "If you assign a supervisor, they will be able to view this appointment on their Sessions page without affecting their appointments and availability slots."
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.setAssignSupervisorsInput
                              ? _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c("BlSearchBox", {
                                      key:
                                        "select-assign-supervisors-" +
                                        _vm.client.id +
                                        "-" +
                                        _vm.therapistInput,
                                      attrs: {
                                        type: "user",
                                        placeholder: "Select therapist",
                                        options: _vm.assignSupervisorOptions,
                                        searching: _vm.assignSupervisorsLoading,
                                        drop: "up"
                                      },
                                      on: {
                                        search: _vm.fetchSupervisors,
                                        change: function($event) {
                                          _vm.assignSupervisorsInput = $event
                                        }
                                      },
                                      model: {
                                        value: _vm.assignSupervisorsInput,
                                        callback: function($$v) {
                                          _vm.assignSupervisorsInput = $$v
                                        },
                                        expression: "assignSupervisorsInput"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "h-18 px-6 grid grid-cols-2 items-center gap-4 border border-t-0 border-slate-400 rounded-b-3xl bg-pure-white"
            },
            [
              _c("BlInputButton", {
                attrs: { type: "plain", label: "Cancel" },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  label: "Update schedule",
                  disabled: _vm.isDisabledSubmit
                },
                on: { clicked: _vm.onSubmit }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.jumpToOpened
        ? _c("JumpToDateModal", {
            attrs: { currentDate: _vm.selectedDate, dimension: "daily" },
            on: {
              "close-modal": function($event) {
                _vm.jumpToOpened = false
              },
              submit: function($event) {
                return _vm.onDayClick({ date: $event })
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2844742a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2844742a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/SelectRescheduleTimeslot.vue
// module id = null
// module chunks = 